import React from 'react'
import { IoCloseOutline } from "react-icons/io5";
import './Chip.css'
export default function Chip({ onDeleteClicked, label, key }) {
    return (
        <div key={key} className="chip">
            <button onClick={()=>onDeleteClicked(label)}>
                <IoCloseOutline className='chip-close-icon'/>
            </button>
            <span>{label}</span>
        </div>
    )
}
